import { useTranslation } from 'react-i18next';

import BallotIcon from 'shared/assets/icons/BallotOutlinedIcon.svg';
import { DynamicTooltip } from 'shared/ui/Tooltip';

export const PropertyCatalogBadge = () => {
    const { t } = useTranslation();
    const label = t('In property catalog');

    return (
        <DynamicTooltip
            content={label}
            enterDelay={200}
            containerStyle={{ display: 'inline-flex' }}
        >
            <img
                src={String(BallotIcon)}
                alt={label}
                style={{
                    boxSizing: 'content-box',
                    width: '18px',
                    height: '18px',
                }}
            />
        </DynamicTooltip>
    );
};
